<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1>
        <span>品牌</span> x 创意 有趣 x 实用
      </h1>
    </div>
    <div class="anliShare">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide openTan5">
            <img src="../assets/home/MinionsNew.jpg" alt />
          </div>
          <div class="swiper-slide openTan6">
            <img src="../assets/home/NationalGeographic.jpg" alt />
          </div>
          <div class="swiper-slide openTan7">
            <img src="../assets/home/wyeth.jpg" alt />
          </div>
          <!-- 旧的 -->
          <div class="swiper-slide openTan3">
            <img src="../assets/home/LionKing.jpg" alt />
          </div>
          <div class="swiper-slide openTan1">
            <img src="../assets/kehuanli/xinqiudazhan.png" alt />
          </div>
          <!-- <div class="swiper-slide openTan2">
            <img src="../assets/kehuanli/anjia.png" alt />
          </div> -->
          <div class="swiper-slide openTan4">
            <img src="../assets/kehuanli/xiaohuangrenNew.png" alt />
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
      <div class="swiper-pagination-d"></div>
    </div>
    <BottomNav></BottomNav>
    <div class="popupBody" :style="display"></div>
    <div class="swiper-container-d" :style="swiperDisplay">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="brand-first" :style="firstDisplay0">
            <div class="brand-first-tit">
              <span>2020年圣诞季限定小黄人玩具</span>
              <div class="closeAll">×</div>
            </div>
            <div class="brand-first-father">
              <img src="../assets/home/WechatIMG37New.jpg" alt="">
            </div>
          </div>
        </div><div class="swiper-slide">
          <div class="brand-first" :style="firstDisplay1">
            <div class="brand-first-tit">
              <span>惠氏启赋 2020年国家地理整合传播</span>
              <div class="closeAll">×</div>
            </div>
            <div class="brand-first-father">
              <img src="../assets/home/WechatIMG38.jpeg" alt="">
            </div>
          </div>
        </div><div class="swiper-slide">
          <div class="brand-first" :style="firstDisplay2">
            <div class="brand-first-tit">
              <span>惠氏启赋 2020年天猫魔法仙境礼盒</span>
              <div class="closeAll">×</div>
            </div>
            <div class="brand-first-father">
              <img src="../assets/home/WechatIMG39.jpeg" alt="">
            </div>
          </div>
        </div>
        <!-- 旧的 -->
        <div class="swiper-slide">
          <div class="brand-first" :style="firstDisplay">
            <div class="brand-first-tit">
              <span>2019年狮子王真人版电影定制款</span>
              <div class="closeAll">×</div>
            </div>
            <div class="brand-first-father">
              <div class="brand-first-img">
                <div class="brand-first-left">
                  <div class="left-top">
                    <img src="../assets/brand-first-1.png" alt />
                    <div>
                      <p>全链整合IP资源</p>
                      <p>负责匹配+权益+审批+使用管理+产品开发</p>
                      <p>
                        以“
                        <span>天生为王</span>”为主题
                      </p>
                      <p>统筹视觉设计+主题堆头+路演+狮子王系列定制产品</p>
                      <p>打造沉浸式营销推广</p>
                    </div>
                  </div>
                  <div class="left-bottom">
                    <img src="../assets/brand-first-2.png" class="brand-first-2" alt />
                    <img src="../assets/brand-first-3.png" class="brand-first-3" alt />
                    <img src="../assets/brand-first-4.png" class="brand-first-4" alt />
                  </div>
                </div>
                <div class="brand-first-right">
                  <img src="../assets/brand-first-5.png" alt />
                </div>
              </div>
              <div class="brand-first-bg-left">
                <img src="../assets/brand-first-bg-left.png" alt />
              </div>
              <div class="brand-first-bg-right">
                <img src="../assets/brand-first-bg-right.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="brand-second" :style="secondDisplay">
            <div class="brand-second-tit">
              <span>2018年圣诞小黄人</span>
              <div class="closeAll">×</div>
            </div>
            <div class="brand-second-father">
              <div class="brand-second-img">
                <div class="img-top">
                  <div class="img-top-1">
                    <img src="../assets/brand-second-1-new.png" alt />
                    <div>
                      <p>结合品牌调性、IP形象及节日，打造爆点话题</p>
                    </div>
                  </div>
                  <img src="../assets/brand-second-2-new.png" class="img-top-2" alt />
                  <img src="../assets/brand-second-3.png" class="img-top-3" alt />
                  <div class="img-top-4">
                    <p>融合产品制作主题场景</p>
                    <p>引发刷屏事件</p>
                  </div>
                </div>
                <div class="img-bottom">
                  <img src="../assets/brand-second-4.png" class="img-bottom-1" alt />
                  <div>
                    <p>社交声量推动销售</p>
                    <p>提前完成销售计划</p>
                  </div>
                  <img src="../assets/brand-second-4-1-new.png" class="img-bottom-2" alt />
                </div>
              </div>
              <div class="brand-second-bg-left">
                <img src="../assets/brand-first-bg-left.png" alt />
              </div>
              <div class="brand-second-bg-right">
                <img src="../assets/brand-first-bg-right.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="brand-third" :style="thirdDisplay">
            <div class="brand-third-tit">
              <span>2019年安佳奶片机</span>
              <div class="closeAll">×</div>
            </div>
            <div class="brand-third-father">
              <div class="brand-third-img">
                <div class="img-top">
                  <div>
                    <p>安佳新春活动定制</p>
                    <p>创新玩法 丰富产品形态</p>
                    <p>操作简单 配合延展道具更有趣</p>
                    <div></div>
                  </div>
                  <img src="../assets/brand-third-1.png" class="img-top-1" alt />
                  <img src="../assets/brand-third-2.png" class="img-top-2" alt />
                </div>
                <div class="img-bottom">
                  <img src="../assets/brand-third-3.png" class="img-bottom-1" alt />
                  <img src="../assets/brand-third-4.png" class="img-bottom-2" alt />
                  <img src="../assets/brand-third-5.png" class="img-bottom-3" alt />
                  <img src="../assets/brand-third-6.png" class="img-bottom-4" alt />
                </div>
              </div>
              <div class="brand-third-bg-left">
                <img src="../assets/brand-third-bg-1.png" alt />
              </div>
              <div class="brand-third-bg-right">
                <img src="../assets/brand-third-bg-1.png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="brand-fourth" :style="fourthDisplay">
            <div class="brand-fourth-tit">
              <span>2019年百事可乐x星球大战</span>
              <div class="closeAll">×</div>
            </div>
            <div class="brand-fourth-father">
              <div class="brand-fourth-img">
                <div class="img-left">
                  <img src="../assets/brand-fourth-1.png" alt />
                  <div>
                    <img src="../assets/brand-fourth-3.png" class="img-left-1" alt />
                    <img src="../assets/brand-fourth-4.png" class="img-left-2" alt />
                  </div>
                </div>
                <div class="img-middle">
                  <img src="../assets/brand-fourth-2.png" alt />
                  <div>
                    <p>品牌联动全球知名电影IP</p>
                    <p>借助粉丝热度 持续话题发酵</p>
                    <p>丰富消费者体验 促进产品销售</p>
                  </div>
                </div>
                <div class="img-right">
                  <img src="../assets/brand-fourth-5.png" alt />
                </div>
              </div>
              <div class="brand-fourth-bg-left">
                <img src="../assets/brand-fourth-left.png" alt />
              </div>
              <div class="brand-fourth-bg-right">
                <img src="../assets/brand-fourth-right.png" alt />
              </div>
              <div class="brand-fourth-bg-top">
                <img src="../assets/brand-fourth-top.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Add Arrows -->
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="swiper-pagination" :style="pointDisplay"></div>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Marketing",
  data() {
    return {
      display: [{ display: "none" }],
      firstDisplay0: [{ display: "block" }],
      firstDisplay1: [{ display: "block" }],
      firstDisplay2: [{ display: "block" }],
      firstDisplay: [{ display: "block" }],
      secondDisplay: [{ display: "block" }],
      thirdDisplay: [{ display: "block" }],
      fourthDisplay: [{ display: "block" }],
      swiperDisplay: [{ display: "none" }],
      pointDisplay: [{ display: "none" }],
      imgBox: [
        {
          id: 0,
          imgSrc: require("../assets/kehuanli-1.jpg"),
          className: "dianji1"
        },
        {
          id: 1,
          imgSrc: require("../assets/kehuanli-2.jpg"),
          className: "dianji2"
        },
        {
          id: 2,
          imgSrc: require("../assets/kehuanli-3.jpg"),
          className: "dianji3"
        },
        {
          id: 3,
          imgSrc: require("../assets/kehuanli-4.jpg"),
          className: "dianji4"
        }
      ],
      index: [
        {
          index: 0
        }
      ]
    };
  },
  methods: {
    // closeAll() {
    //   this.display = { display: "none" };
    //   this.firstDisplay = { display: "none" };
    //   this.secondDisplay = { display: "none" };
    //   this.thirdDisplay = { display: "none" };
    //   this.fourthDisplay = { display: "none" };
    // },
    // openTan1() {
    //   this.fourthDisplay = { display: "block" };
    //   this.display = { display: "block" };
    // },
    // openTan2(){
    //   this.thirdDisplay = { display: "block" };
    //   this.display = { display: "block" };
    // },
    // openTan3(){
    //   this.firstDisplay = { display: "block" };
    //     this.display = { display: "block" };
    // },
    // openTan4(){
    //   this.secondDisplay = { display: "block" };
    //     this.display = { display: "block" };
    // }
  },
  mounted() {
    this.index[0].index = this.$route.params.b;
    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;
      } else {
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;
      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
    var swiper = new Swiper(".swiper-container", {
      loop: true,
      initialSlide: 0,
      autoplay: true,
      pagination: {
        el: ".swiper-pagination-d"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    var swiperd = new Swiper(".swiper-container-d", {
      observer: true,
      observerParents: true,
      loop: true,
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    if (this.index[0].index == 0) {
      swiper.slideTo(5);
    }
    if (this.index[0].index == 1) {
      swiper.slideTo(2);
    }
    if (this.index[0].index == 2) {
      swiper.slideTo(3);
    }
    if (this.index[0].index == 3) {
      swiper.slideTo(4);
    }
    $(".openTan1").click(function() {
      $(".brand-fourth").css({ display: "block" });
      $(".popupBody").css({ display: "block" });
      $(".swiper-container-d").css({ display: "block" });
      $(".swiper-pagination").css({ display: "block" });
      swiperd.slideTo(7);
    });
    $(".openTan2").click(function() {
      $(".brand-third").css({ display: "block" });
      $(".popupBody").css({ display: "block" });
      $(".swiper-container-d").css({ display: "block" });
      $(".swiper-pagination").css({ display: "block" });
      swiperd.slideTo(6);
    });
    $(".openTan3").click(function() {
      $(".brand-first").css({ display: "block" });
      $(".popupBody").css({ display: "block" });
      $(".swiper-container-d").css({ display: "block" });
      $(".swiper-pagination").css({ display: "block" });
      swiperd.slideTo(4);
    });
    $(".openTan4").click(function() {
      $(".brand-second").css({ display: "block" });
      $(".popupBody").css({ display: "block" });
      $(".swiper-container-d").css({ display: "block" });
      $(".swiper-pagination").css({ display: "block" });
      swiperd.slideTo(5);
    });
    $(".openTan5").click(function() {
      $(".brand-second").css({ display: "block" });
      $(".popupBody").css({ display: "block" });
      $(".swiper-container-d").css({ display: "block" });
      $(".swiper-pagination").css({ display: "block" });
      swiperd.slideTo(1);
    });
    $(".openTan6").click(function() {
      $(".brand-second").css({ display: "block" });
      $(".popupBody").css({ display: "block" });
      $(".swiper-container-d").css({ display: "block" });
      $(".swiper-pagination").css({ display: "block" });
      swiperd.slideTo(2);
    });
    $(".openTan7").click(function() {
      $(".brand-second").css({ display: "block" });
      $(".popupBody").css({ display: "block" });
      $(".swiper-container-d").css({ display: "block" });
      $(".swiper-pagination").css({ display: "block" });
      swiperd.slideTo(3);
    });
    $(".closeAll").click(function() {
      $(".popupBody").css({ display: "none" });
      $(".swiper-container-d").css({ display: "none" });
      $(".swiper-pagination").css({ display: "none" });
    });
  },
  components: { Nav, BottomNav }
};
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 4px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  // min-width: 1240px;
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    @media screen and (min-width: 140px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.anliShare {
  padding: 100px 0;
  width: 65%;
  // min-width: 1240px;
  margin: 0 auto;

  /deep/ &-imgheight {
    height: 479px;
  }
  img {
    width: 100%;
    // height: 100%;
  }
}
.dianji1:hover {
  cursor: pointer;
}
.dianji2:hover {
  cursor: pointer;
}
.dianji3:hover {
  cursor: pointer;
}
.dianji4:hover {
  cursor: pointer;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.popupBody {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  z-index: 1000;
  opacity: 0.8;
}
.brand-first {
  position: absolute;
  top: 0;
  width: 1240px;
  z-index: 10000;
  .brand-first-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 28px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-first-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-first-img {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      .brand-first-left {
        .left-top {
          display: flex;
          justify-content: space-between;
          img {
            width: 297px;
            height: 185px;
          }
          div {
            width: 483px;
            height: 155px;
            background: rgba(252, 224, 79, 1);
            margin-left: 14px;
            padding-top: 30px;
            p {
              color: rgba(51, 51, 51, 1);
              margin: 0;
              line-height: 25px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
              span {
                color: rgba(51, 51, 51, 1);
              }
            }
          }
        }
        .left-bottom {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;
          .brand-first-2 {
            width: 422px;
            height: 282px;
          }
          .brand-first-3 {
            width: 156px;
            height: 282px;
          }
          .brand-first-4 {
            width: 188px;
            height: 282px;
          }
        }
      }
      .brand-first-right {
        margin-left: 20px;
        img {
          width: 239px;
          height: 477px;
          margin-left: -10px;
        }
      }
    }
  }
  .brand-first-bg-left {
    position: absolute;
    bottom: 30px;
    left: 0;
  }
  .brand-first-bg-right {
    position: absolute;
    bottom: 20px;
    right: 0;
  }
}
.brand-second {
  position: absolute;
  top: 0;
  width: 1240px;
  z-index: 10000;
  .brand-second-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 28px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-second-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-second-img {
      position: relative;
      z-index: 2;
      .img-top {
        display: flex;
        justify-content: space-between;
        .img-top-1 {
          img {
            width: 340px;
            height: 202px;
          }
          div {
            width: 340px;
            height: 31px;
            background: rgba(252, 224, 79, 1);
            p {
              height: 16px;
              font-size: 16px;
              color: rgba(51, 51, 51, 1);
              margin-top: 15px;
              line-height: 31px;
              @media screen and (min-width: 140px) {
                font-size: 14px;
              }
              @media screen and (min-width: 1920px) {
                font-size: 16px;
              }
            }
          }
        }
        .img-top-2 {
          width: 351px;
          height: 248px;
        }
        .img-top-3 {
          width: 160px;
          height: 247px;
        }
        .img-top-4 {
          width: 40px;
          height: 246px;
          background: rgba(252, 224, 79, 1);
          display: flex;
          justify-content: space-between;
          padding: 0 50px;
          color: rgba(51, 51, 51, 1);
          p {
            width: 20px;
            color: rgba(51, 51, 51, 1);
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
      .img-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 23px;
        .img-bottom-1 {
          width: 450px;
          height: 213px;
        }
        div {
          width: 230px;
          height: 43px;
          background: rgba(252, 224, 79, 1);
          padding: 85px 0;
          color: rgba(51, 51, 51, 1);
          line-height: 25px;
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
          p {
            margin: 0;
          }
        }
        .img-bottom-2 {
          width: 323px;
          height: 213px;
        }
      }
    }
  }
  .brand-second-bg-left {
    position: absolute;
    bottom: 30px;
    left: 0;
  }
  .brand-second-bg-right {
    position: absolute;
    bottom: 20px;
    right: 0;
  }
}
.brand-third {
  position: absolute;
  top: 0;
  width: 1240px;
  z-index: 10000;
  .brand-third-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 28px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-third-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-third-img {
      position: relative;
      z-index: 2;
      .img-top {
        display: flex;
        justify-content: space-between;
        & > div {
          width: 519px;
          height: 77px;
          background: rgba(252, 224, 79, 1);
          padding: 75px 0;
          position: relative;

          p {
            color: #333;
            margin: 0;
            line-height: 25px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
          & > div {
            width: 519px;
            height: 227px;
            background: rgba(21, 21, 21, 1);
            position: absolute;
            z-index: -1;
            top: -18px;
            left: -18px;
            display: flex;
          }
        }
        .img-top-1 {
          width: 185px;
          height: 230px;
        }
        .img-top-2 {
          width: 328px;
          height: 213px;
        }
      }
      .img-bottom {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .img-bottom-1 {
          width: 173px;
          height: 250px;
        }
        .img-bottom-2 {
          width: 282px;
          height: 250px;
        }
        .img-bottom-3 {
          width: 251px;
          height: 250px;
        }
        .img-bottom-4 {
          width: 239px;
          height: 250px;
        }
      }
    }
  }
  .brand-third-bg-left {
    position: absolute;
    top: 40px;
    left: 65px;
    z-index: 111;
  }
  .brand-third-bg-right {
    position: absolute;
    top: 188px;
    right: 29px;
  }
}
.brand-fourth {
  position: absolute;
  top: 0;
  width: 1240px;
  z-index: 10000;
  .brand-fourth-tit {
    padding: 0 110px;
    height: 62px;
    background: #000;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: space-between;
    span {
      line-height: 62px;
      font-size: 30px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
    }
    div {
      width: 31px;
      height: 31px;
      border-radius: 50%;
      background-color: #fce04f;
      border: none;
      margin-top: 15px;
      font-size: 30px;
      text-align: center;
      line-height: 28px;
    }
    div:hover {
      cursor: pointer;
    }
  }
  .brand-fourth-father {
    background-color: #ffffff;
    padding: 46px 110px 20px 110px;
    position: relative;
    .brand-fourth-img {
      position: relative;
      z-index: 2;
      display: flex;
      justify-content: space-between;
      .img-left {
        margin-right: 14px;
        & > img {
          width: 317px;
          height: 222px;
        }
        div {
          position: relative;
          margin-top: 47px;
          .img-left-1 {
            width: 284px;
            height: 136px;
          }
          .img-left-2 {
            position: absolute;
            top: 90px;
            left: 58px;
            width: 200px;
            height: 104px;
          }
        }
      }
      .img-middle {
        margin-right: 14px;
        img {
          width: 399px;
          height: 223px;
        }
        div {
          width: 399px;
          height: 166px;
          background: rgba(252, 224, 79, 1);
          padding-top: 80px;
          margin-top: 5px;
          p {
            // height: 72px;
            font-size: 16px;
            color: #333;
            width: 289px;
            margin: 0;
            padding: 0 55px;
            line-height: 25px;
            @media screen and (min-width: 140px) {
              font-size: 14px;
            }
            @media screen and (min-width: 1920px) {
              font-size: 16px;
            }
          }
        }
      }
      .img-right {
        width: 304px;
        height: 479px;
        img {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
  .brand-fourth-bg-left {
    position: absolute;
    bottom: 29px;
    left: 0;
    z-index: 111;
  }
  .brand-fourth-bg-right {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .brand-fourth-bg-top {
    position: absolute;
    top: 136px;
    right: 32px;
  }
}
.swiper-pagination-d {
  // width: 5.2%;
  height: 30px;
  padding: 0 48.25%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (min-width: 140px) {
    width: 10%;
  }
  @media screen and (min-width: 1520px) {
    width: 8%;
  }
}
.swiper-pagination {
  position: fixed;
  bottom: 10%;
  left: 48%;
  z-index: 10000;
  display: flex;
  justify-content: space-between;
  width: 100px !important;
  .swiper-pagination-bullet-active {
    color: #ccc;
  }
  & > span {
    margin-right: 50px;
  }
}
.swiper-pagination-bullet {
  margin-right: 10px !important;
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 40px;
}
.swiper-button-next:after {
  margin-left: 20px;
}
.swiper-button-prev:after {
  margin-right: 20px;
}
.swiper-slide {
  width: 200px;
  // height: 521px;
  img {
    width: 100%;
  }
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 30px;
}
.swiper-button-next:after {
  margin-left: 5px;
  color: #fff;
}
.swiper-button-prev:after {
  margin-right: 5px;
  color: #fff;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.swiper-container-d {
  width: 1240px;
  height: 689px;
  position: fixed;
  top: 50%;
  margin-top: -345px;
  left: 50%;
  margin-left: -620px;
  z-index: 10000;
  overflow: hidden;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
</style>
<style lang="less">
// .el-carousel__container {
//   height: 500px;
// }
.el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.anliShare .el-carousel__container {
  height: 521px;
}
// .el-submenu__title:hover{
//   background-color: #fff !important;
// }
.el-submenu__title {
  color: #333 !important;
}
.el-submenu__title a {
  color: #333 !important;
}
:root {
  --swiper-theme-color: rgb(215, 217, 222) !important;
}
</style>
